function getReferredOONProgram(programs = []) {
  return programs.find((program = {}) => program.attributes.default) || {};
}

export default getReferredOONProgram;
